import { getSpacing } from 'ui/theme'

export enum ModalSpacing {
  SM = getSpacing(4),
  MD = getSpacing(6),
  LG = getSpacing(8),
}
